import request from "../utils/request";

// set base URL relative to subfolder (ex. example.com/stores/locator/)
const scriptName = document.querySelector('meta[name="script-name"]').content;
const isOperateWithoutTrailingSlash =
  document
    .getElementById("operate_without_trailing_slash")
    .getAttribute("content") === "True";

export function fetchBanner() {
  return request({
    url: `${scriptName}/api/get-banner${isOperateWithoutTrailingSlash ? "" : "/"}`,
    method: "get",
  });
}
